import { render, staticRenderFns } from "./teste.vue?vue&type=template&id=9a3a9dd0&scoped=true&"
import script from "./teste.vue?vue&type=script&lang=js&"
export * from "./teste.vue?vue&type=script&lang=js&"
import style0 from "./teste.vue?vue&type=style&index=0&id=9a3a9dd0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a3a9dd0",
  null
  
)

export default component.exports